export const tooltipStyles = {
  contentStyle: {
    background: '#090d1f',
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: 12,
    color: '#f6f9ff',
    boxShadow: '0 12px 24px rgba(0,0,0,0.45)'
  },
  labelStyle: {
    color: '#f6f9ff',
    fontWeight: 600
  },
  itemStyle: {
    color: '#f6f9ff'
  },
  wrapperStyle: {
    zIndex: 2000,
    pointerEvents: 'auto'
  }
} as const;
